export default function InputText({
  label,
  value,
  onChange,
  unit,
  id,
  name,
  lock = false,
  haveFlex1 = false,
}) {
  return (
    <div
      className={`${haveFlex1 ? "flex-1 min-w-0" : "w-full"} rounded-lg text-sm flex items-center gap-2.5 bg-zi-bg1-light dark:bg-zi-inputbg-dark text-zi-text-light dark:text-zi-text-dark ${
        lock === false
          ? "hocus-within:ring-1 hocus-within:ring-zi-border-dark hocus-within:dark:ring-zi-border-light/30"
          : ""
      }`}
    >
      <label htmlFor={id} className="pr-2.5 py-1.5 opacity-50">
        {label}
      </label>
      <input
        type="text"
        id={id}
        name={name}
        value={value}
        onInput={onChange}
        readOnly={lock}
        autoComplete="off"
        inputmode="decimal"
        pattern="[0-9.]*"
        className={`flex-1 outline-none bg-transparent font-medium [direction:ltr] py-1.5 min-w-0 ${
          lock === true ? "pointer-events-none" : ""
        }`}
      />
      {!lock && (
        <label className="pl-2.5 py-1.5 opacity-50" htmlFor={id}>
          {unit}
        </label>
      )}
      {lock && (
        <label className="pl-2.5 py-1.5 opacity-0" htmlFor={id}>
          {unit}
        </label>
      )}
    </div>
  );
}
